import Api from './Api'
import ApiS3  from './ApiS3'

export default {
  getOrders () {
    return Api().get('/order/all')
  },
  getApproverOrders (userId) {
    const params = {
      params: {}
    }
    if(userId) {
      params.params.userId = userId;
    }
    return Api().get('/order/user', params)
  },
  getOrderDetails (orderNumber) {
    const params = {
      params: {}
    }
    if(orderNumber) {
      params.params.orderNumber = orderNumber;
    }
    return Api().get('/order/', params)
  },
  setOrderStatus(orderId, status, revisedMessage, tooManyItems, tooCloseToEvent, stillNeeded, additionalComments) {
    return Api().post('/order/status', {
      orderId,
      status,
      revisedMessage,
      tooManyItems,
      tooCloseToEvent,
      stillNeeded,
      additionalComments
    })
  },
  setShippingStatus(orderId, status, trackingNumbers, fileName){
    return Api().post('/order/shipping', {
      orderId,
      status,
      trackingNumbers,
      fileName
    }
    )
  },
  uploadLabelZip(url, file){
    return ApiS3().put(url, file)
  },
  resendPendingEmail(email, orderId){
    return Api().post('/order/resendPending', {
      email,
      orderId
    })
  }
}